import { AssetClassType } from "../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ViewType } from "../../../../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";

export enum tabContent {
    Summary = "Summary",
    Investments = "Investments",
    Performance = "Performance",
    Insights = "Insights",
    Transactions = "Transactions",
    Documents = "Documents",
    AccountInfo = "Account info",
}

export const InvestmentType = {
    IndividualInvestments: { title: "Investment holdings", key: "holdings" },
    ModelPortfolioInvestments: { title: "Managed portfolios", key: "portfolios" },
    OffPlatformInvestments: { title: "Off Platform Investments", key: "opi" },
};

export const tabContentArray = [
    tabContent.Summary,
    tabContent.Investments,
    tabContent.Performance,
    tabContent.Insights,
    tabContent.Transactions,
    tabContent.Documents,
    tabContent.AccountInfo,
];

export const AssetClassTypeArray = [AssetClassType.Tier1, AssetClassType.Tier2, AssetClassType.NotSet];

export const AssetClassTypeMap = {
    [AssetClassType.Tier1]: "Tier 1",
    [AssetClassType.Tier2]: "Tier 2",
    [AssetClassType.NotSet]: "No Tiers",
};

export const AssetClassTypeTiersArray = [AssetClassType.Tier1, AssetClassType.Tier2];

export const AssetClassTypeTiersMap = {
    [AssetClassType.Tier1]: "Tier 1",
    [AssetClassType.Tier2]: "Tier 2",
};

export const ViewTypeArray = [ViewType.Product, ViewType.Asset];

export const ViewTypeMap = {
    [ViewType.Product]: "Product",
    [ViewType.Asset]: "Asset",
};

export const clientDashboardHeaderContents = {
    lastLoginLabel: (numberOfDays: number) => ` Client last logged in ${numberOfDays} days ago`,
    ClientPortalViewLabel: "Client's portal view",
    AppStoreLaunchPad: "Launch Apps",
    totalPortfolioValueLabel: "Total portfolio value as at",
};

export const SubAccountTypeMap = {
    NotSpecified: 0,
    InvestmentAccount: 1,
    CashIsa: 2,
    StocksIsa: 3,
    AuAccumulation: 4,
    AuPension: 5,
    Pension: 6,
    OffshoreBond: 7,
    OnshoreBond: 8,
    CashAccount: 9,
    Sipp: 10,
    RetailSipp: 11,
    PersonalPortfolio: 12,
    RetailBond: 13,
    WrapCash: 14,
    Pep: 15,
    OrsoRa: 16,
    OrsoSa: 17,
    JuniorIsa: 18,
    JuniorSipp: 19,
    Npr: 20,
    Pr: 21,
    Other: 22,
};

export const RestrictionReasonType = {
    SubjectToEuUn : 1,
    LegalCourtOrder : 2,
    SuspectedFraud : 3,
    Fraudulent : 4,
    NoAmlPass : 5,
    Pep : 6,
    AmlSar : 7,
    AuthorityRequest : 8,
    HighRiskCustomer : 9,
    IncreasedClientSecurityRequired : 10,
    DeathIndividual : 11,
    DeathJoint : 12,
    FinancialSanction : 13,
    LiquidationEmployerContributions : 14,
    Liquidation : 15,
    Bankruptcy : 16,
    PensionSharingOrder : 17,
    GoneAwayEarly : 18,
    GoneAwayNoContact : 19
}
